export const formatNumber = (num?: number) => {
  if (num === undefined) return "0";
  return new Intl.NumberFormat().format(Math.round(num));
};

/**
 * Numero que puede ser desconocido.
 *
 * formatNumber devuelve "0" para undefined, lo que en una metrica de reach es
 * una afirmacion falsa: no es que no se alcanzara a nadie, es que no se sabe.
 * El backend deja esas metricas sin definir precisamente para poder
 * distinguirlo, asi que aqui se respeta.
 *
 * El fallback se puede cambiar por cadena vacia para las filas de CSV, donde
 * una celda en blanco se lee mejor que un guion.
 */
export const formatNumberOrUnknown = (num?: number | null, fallback = "—") =>
  num === undefined || num === null ? fallback : formatNumber(num);

export const formatCurrency = (num?: number, currency?: string) => {
  if (num === undefined) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: 2,
  }).format(num);
};

export const formatPercentage = (num?: number) => {
  if (num === undefined) return "0.00%";
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
  }).format(num);
};

/**
 * Formats a number as a percentage without multiplying by 100.
 * Use this when your value is already in percentage form (e.g., 50 for 50%).
 */
export const formatPercentageNoMultiply = (num?: number) => {
  if (num === undefined) return "0.00%";
  // Divide by 100 to counteract the automatic multiplication
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
  }).format(num / 100);
};

export const formatDecimal = (num?: number, fractionDigits = 2) => {
  if (num === undefined || Number.isNaN(num)) {
    return Number(0).toFixed(fractionDigits);
  }

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(num);
};
